export default __webpack_public_path__ + "static/media/Molido.ab41458f.JPG";